<template>
  <div>
    <div class="container">
      <div>
        <h3 class="text-center c-orange text-uppercase mt-3 mb-1">
          Menor Preço Cliente
        </h3>
        <p class="text-center mb-5">
          Aqui você, sempre encontra o menor preço e economiza!
        </p>
      </div>
      <div>
        <h5 class="text-center text-uppercase mt-3 mb-3">
          Escolha os seguimentos a baixo
        </h5>
      </div>
      <b-tabs content-class="mt-3" fill>
        <!-- BASICO -->
        <b-tab active>
          <template #title>
            <strong><i class="fas fa-hammer mr-3"></i>BÁSICO</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - Basico
            </h3>
            <div class="row">
              <!-- CARD 01 -->
              <div
                class="mr-2 mb-2"
                v-for="(prod, index) in data.basico"
                :key="index"
              >
                <div
                  class="card shadow bg-light rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    :src="`${pathImg}basico/` + prod.img"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h5 class="card-title text-uppercase c-orange">
                      {{ prod.produtos }}
                    </h5>
                    <span class="card-text text-uppercase">
                      {{ prod.marca }}
                    </span>
                    <div class="mb-2 mt-2">
                      <span>preço a partir de (à vista):</span>
                    </div>

                    <div class="mb-2">
                      <h5 class="card-text text-uppercase text-danger">
                        {{ prod.min_preco }}
                      </h5>
                    </div>

                    <div>
                      <i class="fas fa-map-marker-alt"></i>
                      <span class="ml-2 text-uppercase">{{ city }}</span>
                    </div>
                    <a
                      @click="makeQuote(prod.produtos)"
                      class="btn btn-success text-uppercase mt-2"
                      >Confira Disponibilidade</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- ELETRICA -->
        <b-tab>
          <template #title>
            <strong><i class="fas fa-bolt mr-3"></i>ELETRICO</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - ELETRICO
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div
                class="mr-2 mb-2"
                v-for="(prod, index) in data.eletrico"
                :key="index"
              >
                <div
                  class="card shadow bg-light rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    :src="`${pathImg}eletrico/` + prod.img"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h5 class="card-title text-uppercase c-orange">
                      {{ prod.produtos }}
                    </h5>
                    <span class="card-text text-uppercase">
                      {{ prod.marca }}
                    </span>
                    <div class="mb-2 mt-2">
                      <span>preço a partir de (à vista):</span>
                    </div>

                    <div class="mb-2">
                      <h5 class="card-text text-uppercase text-danger">
                        {{ prod.min_preco }}
                      </h5>
                    </div>

                    <div>
                      <i class="fas fa-map-marker-alt"></i>
                      <span class="ml-2 text-uppercase">{{ city }}</span>
                    </div>
                    <a
                      @click="goToQuote(1)"
                      class="btn btn-success text-uppercase mt-2"
                      >Confira Disponibilidade</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- HIDRAULICA -->
        <b-tab>
          <template #title>
            <strong><i class="fas fa-shower mr-3"></i>HIDRAULICA</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - HIDRAULICA
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div
                class="mr-2 mb-2"
                v-for="(prod, index) in data.hidraulico"
                :key="index"
              >
                <div
                  class="card shadow bg-light rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    :src="`${pathImg}hidraulico/` + prod.img"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h5 class="card-title text-uppercase c-orange">
                      {{ prod.produtos }}
                    </h5>
                    <span class="card-text text-uppercase">
                      {{ prod.marca }}
                    </span>
                    <div class="mb-2 mt-2">
                      <span>preço a partir de (à vista):</span>
                    </div>

                    <div class="mb-2">
                      <h5 class="card-text text-uppercase text-danger">
                        {{ prod.min_preco }}
                      </h5>
                    </div>

                    <div>
                      <i class="fas fa-map-marker-alt"></i>
                      <span class="ml-2 text-uppercase">{{ city }}</span>
                    </div>
                    <a
                      @click="goToQuote(1)"
                      class="btn btn-success text-uppercase mt-2"
                      >Confira Disponibilidade</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- FERRAGENS -->
        <b-tab>
          <template #title>
            <strong><i class="fab fa-uniregistry mr-3"></i>FERRAGENS</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - Ferragens
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div
                class="mr-2 mb-2"
                v-for="(prod, index) in data.ferragem"
                :key="index"
              >
                <div
                  class="card shadow bg-light rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    :src="`${pathImg}ferragens/` + prod.img"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h5 class="card-title text-uppercase c-orange">
                      {{ prod.produtos }}
                    </h5>
                    <span class="card-text text-uppercase">
                      {{ prod.marca }}
                    </span>
                    <div class="mb-2 mt-2">
                      <span>preço a partir de (à vista):</span>
                    </div>

                    <div class="mb-2">
                      <h5 class="card-text text-uppercase text-danger">
                        {{ prod.min_preco }}
                      </h5>
                    </div>

                    <div>
                      <i class="fas fa-map-marker-alt"></i>
                      <span class="ml-2 text-uppercase">{{ city }}</span>
                    </div>
                    <a
                      @click="makeQuote(prod.produtos)"
                      class="btn btn-success text-uppercase mt-2"
                      >Confira Disponibilidade</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import makeToast from '../../mixins/makeToast';
export default {
  mixins: [makeToast],
  data() {
    return {
      pathImg: process.env.VUE_APP_API_URL+'segmentos/',
      data: [],
      city: '',
    };
  },
  created() {
    this.getCity();
    this.getClient(); 
  },
  mounted() {
    this.getCity();
  },

  methods: {
    makeQuote(prod) {
      let lowestPrice = {
        produto: prod,
      };
      localStorage.setItem('lowestPrice', prod);
      this.$router.push({ name: 'fazer-cotacao' });
    },
    getCity() {
      const user = JSON.parse(localStorage.getItem('dadosUsuario'));
      console.log(user);
      this.city = user.informacoes.cidade;
    },

    getClient() {
      this.getCity();
      console.log(this.city);
      this.$store.dispatch('client/getClient', this.city).then((response) => {
        this.data = response.data;
        console.log(this.data);
        console.log("DATA")
      });
    },
  },
};
</script>

<style scoped>
h5 {
  font-size: clamp (1.75em, 1em +3wv, 2.5em);
}
</style>
